(function() {
    // NO IFRAME => NO NEED FOR RESIZE
    if (top === self) {
        return;
    }

    var frameElement,
        doc;

    // iframe resize
    var iFrameResize = function(oldHeight) {
        var resizerTimeout, height;
        
        try {
            frameElement = frameElement || window.frameElement;
            doc = doc || 'contentDocument' in frameElement ? frameElement.contentDocument : frameElement.contentWindow.document;
            height = doc.body.offsetHeight;
            oldHeight = oldHeight || parseInt(frameElement.style.height);
            if (height !== oldHeight) {
                frameElement.style.height = height + 'px';
            }

            resizerTimeout = setTimeout(iFrameResize, 250);

        } catch(e) {
            if (typeof window.console === 'function') {
                window.console.log('iFrame Resizer Error - maybe we are still in preview mode?');
            }
            clearTimeout(resizerTimeout);
        }
        
    };

    var onLoad = function() {
        iFrameResize();
    };

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        onLoad();
    } else {
        window.onload = onLoad;
    }
})();

define("mmc.libs.iFrameResizer", function(){});

